import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ElementRef,
} from '@angular/core';
import { AemService, IArSubscription, IConfigObj, IDataConfig } from 'abs-ngx-library/src/lib/core';
import { ArService , CommonService} from 'abs-ngx-library/src/lib/core';
import { ProductSNSModalALService } from './product-sns-modal-al.service';

declare let $: any;

@Component({
    selector: 'product-sns-modal-al',
    templateUrl: './product-sns-modal-al.component.html'
})

export class ProductSNSModalALComponent implements OnInit {

  @Output() closeModalEvent = new EventEmitter<void>();
  @Output() selectFrequency = new EventEmitter<number>();

  public arSubscriptionList: IArSubscription;
  public formModel: { frequency: number | string };
  public dataConfig: IDataConfig;
  private qscQuantity: number = 1;
  private recurringFrequency: string = "1";
  public configObj: IConfigObj = {
    programType : 'abs'
  }

  constructor(private _arService: ArService,
    private _productSnsModalService: ProductSNSModalALService, public elementRef: ElementRef,  private _commonService: CommonService, private _aemService: AemService ){
  }

  ngOnInit(): void {
    this.formModel = { frequency: this.dataConfig.selectedFrequency};
    this.dataConfig.contents = this._productSnsModalService.getDynamicContents();
  }

  public onKeydownEvent($event, modelId){
    const focusableElements = 'button:not([disabled]), [href], input, select, textarea, a, [tabindex]:not([tabindex="-1"])';
    this._commonService.handleTabFocus($event, modelId, this.elementRef.nativeElement, focusableElements);
  }

  closeModal(){
    this.closeModalEvent.emit();
  }

  saveFrequency(){
    this._productSnsModalService.emitFrequency(this.formModel.frequency);

    this.closeModal();
    this.analyticsSnsModalClick('ar:frequency|save')
  }

  getFocusableElements(selector){
    const focusableContent: HTMLElement[] = this.elementRef.nativeElement.querySelectorAll(selector);
    const visibleFocusableElement: HTMLElement[] = [];
    focusableContent.forEach((focusable) => {
      if ($(focusable).is(':visible')) {
          visibleFocusableElement.push(focusable)
      }
    })
    return visibleFocusableElement;
  }

  clickFrequency(frequency){
    this.formModel.frequency = frequency;
  }

  public getUpdatedQty(quantity) {
    this.qscQuantity = quantity;
  }

  public saveRecurringFreq(frequency) {
    this.recurringFrequency = frequency;
  }

  public saveRecurringDetails() {
    // pass the modal details as payload to addSubscription in object format.
    const productDetails: any = {
      bpn: this.dataConfig.product.id,
      upc: this.dataConfig.product.upc,
      quantity: this.qscQuantity,
      startDate: this.dataConfig.nextFulfillmentDate,
      subscriptionSource: this.dataConfig.subscriptionSource,
      frequency: this.recurringFrequency,
      productTitle: this.dataConfig.product.name,
      originalPrice: this.dataConfig.product.price
    }
    this._arService.buildAndPostAddSubscription(productDetails).subscribe(response => {
      this.closeModal();
      if(!!response){
        // save the POST response to local storage
        this._arService.setArSubscription(response);
        // show success modal
        this.dataConfig.modal = 'successModal';
        this.dataConfig.showModal = true;
        this.dataConfig.productId = productDetails.bpn;
        this.dataConfig.nextFulfillmentType = response.fulfillment?.fulfillmentType.toLowerCase();
        const productObj = response.itemsSubscribed.find(obj => obj.productBpn === this.dataConfig.productId);
        this.dataConfig.productFulfillDate = productObj?.nextFulfillmentDate;
        this.dataConfig.selectedFrequency = productObj?.frequency?.count;
      } else {
        this.closeModal();
        this.dataConfig.modal = 'errorModal';
        this.dataConfig.showModal = true;
        this.dataConfig.errModalType =  'subscribe';
      }
      setTimeout(() => {
        this._productSnsModalService.show(this.dataConfig);
        if (window['AB']?.DATALAYER) {
          window['AB']?.DATALAYER.setSnsModalViewEvents(this.dataConfig);
        }
      }, 200);
    }, (err: any) => {
      // show error modal here
      this.closeModal();
      this.dataConfig.modal = 'errorModal';
      this.dataConfig.showModal = true;
      this.dataConfig.errModalType =  'subscribe';
      setTimeout(() => {
        this._productSnsModalService.show(this.dataConfig);
      }, 200);
    });
  }

  public analyticsLinkClick(link) {
    if (window['AB']?.DATALAYER) {
      window['AB']?.DATALAYER.setSnsModalLinkClick(link, this.dataConfig);
    }
  }

  public analyticsSnsModalClick(action) {
    if (window['AB']?.DATALAYER) {
      window['AB']?.DATALAYER.setSnsModalClickEvents(action, this.dataConfig, this.formModel, this.recurringFrequency);
    }
  }

}
